import "./ReferralProgramLanding.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HowItWorks from "./sections/HowItWorks";
import CoreBenefits from "./sections/CoreBenefits";
import FinalCallToAction from "./sections/FinalCallToAction";
import IndicadoresDeConfianza from "./sections/IndicadoresDeConfianza";
import Footer from "@/reusable_sections/Footer";
export default function ReferralProgramLandingPage() {
  return <div>
      <Header />
      <Hero />
      <HowItWorks />
      <CoreBenefits />
      <FinalCallToAction />
      <IndicadoresDeConfianza />
      <Footer showThemeToggle={false} />
    </div>;
}